import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { motion } from 'framer-motion';
import logo from '../assets/images/Logo/logo.png';

const Hero = () => {
  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center justify-center bg-marina-900 overflow-hidden"
    >
      {/* Fondo con efecto de olas */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-marina-900 via-marina-800 to-marina-700 animate-wave-bg"></div>
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
      </div>
      
      {/* Burbujas animadas - hidden on mobile for performance */}
      {[...Array(12)].map((_, i) => {
        const randomY = Math.random() * 100 + 500;
        const randomOpacity = 0.3 + Math.random() * 0.7;
        const randomScale = 0.2 + Math.random() * 0.8;
        const randomDuration = 10 + Math.random() * 20;
        const randomSize = 10 + Math.random() * 20;
        const randomLeft = Math.random() * 100;
        const bubbleOpacity = 0.3 + Math.random() * 0.3;

        return (
          <motion.div
            key={i}
            initial={{
              y: randomY,
              opacity: randomOpacity,
              scale: randomScale
            }}
            animate={{
              y: -100,
              transition: {
                repeat: Infinity,
                duration: randomDuration,
                ease: "linear"
              }
            }}
            className="absolute rounded-full bg-white hidden sm:block"
            style={{
              width: `${randomSize}px`,
              height: `${randomSize}px`,
              left: `${randomLeft}%`,
              opacity: bubbleOpacity
            }}
          />
        );
      })}

      <div className="container mx-auto px-4 md:px-6 z-10 text-center md:text-left">
        <div className="md:max-w-2xl">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-4 text-white leading-tight">
              El Sabor del Mar <br />
              <span className="text-arena-300">en cada Plato</span>
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl">
              Disfruta de mariscos frescos preparados con pasión y servidos en un ambiente único frente al mar.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 justify-center md:justify-start"
          >
            <ScrollLink
              to="menu"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
            >
              <button className="btn-primary">
                Ver Menú
              </button>
            </ScrollLink>
            <ScrollLink
              to="contact"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
            >
              <button className="btn-secondary">
                Reservar Mesa
              </button>
            </ScrollLink>
          </motion.div>
        </div>
      </div>

      {/* Logo destacado */}
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, delay: 0.5 }}
        className="hidden md:block absolute right-20 top-[25%] z-10"
      >
        <img 
          src={logo} 
          alt="Logo La Barra Brava" 
          className="w-auto h-80 md:h-96 object-contain filter drop-shadow-xl"
        />
      </motion.div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center"
      >
        <span className="text-white text-sm mb-2">Desplázate para descubrir</span>
        <motion.div
          animate={{
            y: [0, 10, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            repeatType: "loop",
          }}
        >
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
